import { render, staticRenderFns } from "./declarationRecord.vue?vue&type=template&id=a232ec66&scoped=true&"
import script from "./declarationRecord.vue?vue&type=script&lang=js&"
export * from "./declarationRecord.vue?vue&type=script&lang=js&"
import style0 from "./declarationRecord.vue?vue&type=style&index=0&id=a232ec66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a232ec66",
  null
  
)

export default component.exports